import React from 'react';
import {Routes} from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import {ColorModeContext, useMode} from "./application/helpers/themeHelper";
import GuestRoutes from "./application/routes/guest";
import ClientRoutes from "./application/routes/client";

function App(){
	const [theme, colorMode] = useMode();
	return (<ColorModeContext.Provider value={colorMode}>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Routes>
				{/* Guest routes */}
				{GuestRoutes()}
				{/* User routes */}
				{ClientRoutes()}
			</Routes>
		</ThemeProvider>
	</ColorModeContext.Provider>);
}

export default App;